class ResultSet {
    constructor(data = [], id = null, timestamp = null, type=null) {
        this.data = data;
        this.id = id || crypto.randomUUID();
        this.timestamp = timestamp || new Date().toISOString();
        this.type = type || null;
    }

    add(item) {
        this.data.push(item);
        return this;
    }

    clear() {
        this.data = [];
        return this;
    }

    toJSON() {
        return {
            data: this.data,
            id: this.id,
            timestamp: this.timestamp,
            type: this.type
        };
    }
}

export default ResultSet;